<template>
  <footer class="footer text-white">
    <div class="footer-inner">
      <!-- Top branding row -->
      <div class="footer-logo-row">
        <div class="footer-brand"><img  src="@/assets/bakers/logodna.png"   alt="logo" ></div>
        <span class="footer-separator">×</span>
        <div class="footer-brand footer-brand-secondary"><img  src="@/assets/bakers/Warburtons-Logo_white.png"   alt="logo" ></div>
      </div>
      <div class="footer-sub">Baking Traits Test</div>
      <p class="footer-text">
        These results are based on known genetic associations and are intended for informational and entertainment purposes only.
        Genetic predispositions do not determine outcomes; environment, training and experience each play a significant role in baking skill.
        <br><br>
        Report version 1.0
        <br><br>
        © 2026 Living DNA Ltd. All rights reserved.
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "AppFooter"
};
</script>

<style lang="scss" scoped>
:root {
  --bg-dark: #1a0f08;
  --gold: #e6c27a;
  --mid: #7a6a5c;
  --light-mid: #bfae9c;
  --text: #9a8b7a;
}

.footer {
  background: #E86D1F;
  padding: 24px 10px;
  display: flex;
  justify-content: center;  
  text-align: center;       
}

/* Center inner content */
.footer-inner {
  max-width: 900px;
  margin: 0 auto;          
}

/* Center the logo row */
.footer-logo-row {
  display: flex;
  justify-content: center;   
  align-items: center;
  gap: 10px;
  flex-wrap: nowrap;
  white-space: nowrap;
  margin-bottom: 16px;
  height:40px;
}

.footer-brand {
  font-size: 20px;
  font-weight: 600;
  color: var(--gold);
  line-height: 1;
}

.footer-brand-secondary {
  font-size: 16px;
  color: var(--light-mid);
}

.footer-separator {
  color: var(--mid);
  font-size: 14px;
  opacity: 0.8;
}

.footer-sub {
  letter-spacing: 3px;
  font-size: 11px;
  color: var(--mid);
  margin-bottom: 16px;
}

.footer-text {
  color: var(--text);
  font-size: 14px;
  line-height: 1.7;
  max-width: 650px;
}

/* ===== CTA Section ===== */
.footer-sub-headline {
  color: #93c5fd;
}

.footer-btn-link {
  color: #fff;
  text-decoration: none;
}

.footer-logo-row img {
  max-width: 150px;
  width: 100%;
  height:50px;
}

.footer-brand-secondary img {
  // max-width: 150px;
  // width: 100%;
  height:30px;
}

/* ===== Grid ===== */
.footer-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 32px 64px;
  margin-top: 64px;

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  li {
    font-size: 14px;
    margin: 0;
  }

  strong {
    font-size: 16px;
  }
}

/* Icons */
.footer-icon {
  font-size: 20px;
  color: #93c5fd;
}

/* ===== Mobile Fix ===== */
@media (max-width: 650px) {
  .footer {
    padding: 40px 20px;
  }

  .footer-logo-row {
    flex-wrap: wrap;
    gap: 8px;
    justify-content: center;
  }

  .footer-brand img {
    max-width: 140px;
    height: auto;
  }

  .footer-brand-secondary img {
    max-width: 120px;
    height: auto;
  }

  .footer-separator {
    font-size: 12px;
  }

  .footer-sub {
    font-size: 10px;
    letter-spacing: 2px;
  }

  .footer-text {
    font-size: 13px;
    line-height: 1.6;
  }
}

@media (max-width: 400px) {
  .footer {
    padding: 30px 16px;
  }

  .footer-brand img {
    max-width: 110px;
  }

  .footer-brand-secondary img {
    max-width: 100px;
  }

  .footer-text {
    font-size: 12px;
  }
}
</style>